import { Action, createReducer, on } from '@ngrx/store';
import { Ingredient, IngredientDTO, IngredientsFilters } from '../../commons/models/ingredient';
import * as IngredientsActions from '../actions/ingredients.actions';


export interface IngredientState {
  list: IngredientDTO[],
  total: number,
  includes: string[],
  currentPage: number,
  perPage: number,
  order: string,
  direction: string,
  filters: IngredientsFilters,
  dialogId: string,
  selectionDialogId: string,
  ingredients: IngredientDTO,
  selectedIngredients: Ingredient[]
};

const initialState: IngredientState = {
  list: [],
  total: 0,
  includes: [],
  currentPage: 1,
  perPage: 25,
  order: null,
  direction: null,
  filters: null,
  dialogId: null,
  selectionDialogId: null,
  ingredients: null,
  selectedIngredients: []
};

const ingredientsReducer = createReducer(
  initialState,
  on(IngredientsActions.loadIngredientsCompleted, (state, { ingredient, currentPage, total, perPage, order, direction, filters, includes }) => {
    return { ...state, list: ingredient, currentPage, total, perPage, order, direction, filters, includes };
  }),

  on(IngredientsActions.ingredientDialogOpened, (state, {dialogId}) => {
    return {...state, dialogId};
  }),
);

export function reducer(state: IngredientState | undefined, action: Action) {
  return ingredientsReducer(state, action);
}